import { crmListObjectType } from "app/pages/sales-intelligence/domain/crm-integration/types/object-type";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { CrmIntegrationObject } from "app/pages/sales-intelligence/domain/leads/types/filter-options";

import CrmFieldsFilterContainer from "../../components/filters/CrmFieldsFilter/CrmFieldsFilterContainer";
import CrmFieldsFilterResultContainer from "../../components/filters/CrmFieldsFilter/CrmFieldsFilterResultContainer";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import type { LeadsSearchFilterInstance } from "../../types/leadsSearchFilterInstance";

import CrmFieldsFilter from "./CrmFieldsFilter";

const trackingNameByIntegration: Record<CrmIntegrationProvider, string> = {
    salesforce: "Salesforce Fields",
    hubspot: "HubSpot Fields",
    dynamics: "Microsoft Dynamics Fields",
};

const createCrmFieldsFilter = (
    config: readonly CrmIntegrationObject[],
    integration: CrmIntegrationProvider,
): LeadsSearchFilterInstance => {
    const fields =
        config.find((c) => c.integrationName == integration && c.objectType == crmListObjectType.accounts)?.fields ??
        [];

    return {
        key: integration,
        trackingName: trackingNameByIntegration[integration],
        apiCategory: "leadsFilters",
        visibility: "always-visible",
        category: leadsFilterCategoryMap.crm,
        title: { key: "si.lead_gen_filters.category.crm.name" },
        tooltipText: { key: `si.lead_gen_filters.category.${integration}.tooltip` },
        filter: new CrmFieldsFilter({
            options: {
                fields: fields,
                integrationName: integration,
            },
        }),
        filterView: CrmFieldsFilterContainer,
        filterResultView: CrmFieldsFilterResultContainer,
    };
};

export default createCrmFieldsFilter;
